import React, { useState } from 'react'

import axios from 'axios';
import { useEffect } from 'react';
import Spinner from './Spinner';
import useGif from '../hooks/useGif';


const API_KEY = process.env.REACT_APP_GIPHY_API_KEY;

const Random = () => {

  // const [gif, setGif] = useState('');
  //   const [loading, setLoading] = useState('false');
  //   //no need of tag here

  //  //below func calls api, gets meme out of it and adds it to gif, gif is a state variable
  //  //since n/w cll takes time so initially loading is set to true
  //   async function fetchData(tag) {
  //     setLoading(true);
  //     //const output = await axios.get(tag ? `${url}&tag=${tag}`  : url);  //destructing done in below line so that we take data from output
  //     const {data} = await axios.get(tag ? `${url}&tag=${tag}`  : url);   //tells how to implement url, like random pr tag based 
  //     const imageSource = data.data.images.downsized_large.url;  //path to get the data we want on screen //whose path is data.data.images.downsized_large.url
  //     setGif(imageSource);  //links imgsrc and gif in const funct using setgif
  //     setLoading(false);
  //   }
    
  //   //above function is called using useeffect below
  //   useEffect( () => {
  //     fetchData('car');
  //   },[] )


  const {gif, loading, fetchData} = useGif();  //we got these 3 from usegif call


  return (
    <div className='w-1/2  bg-red-100 rounded-lg border border-black
    flex flex-col items-center gap-y-5 mt-[15px]'>

      <h1 className='mt-[15px] text-2xl underline uppercase font-bold'> A Random Gif</h1>

    {
        loading ? (<Spinner/>) : (<img src= {gif} width="450" />)
    }

      

      <button onClick={() => fetchData()}
      className="w-10/12 bg-yellow-500 text-lg py-2 rounded-lg mb-[20px]">

       Generate

      </button>

    </div>
  )
}

export default Random

//code looks more better now
//img src= {gif}..gif state has been created in const above
//on clicking btn clickhandler function will be clld......................this function calls fetchdata as random meme is generated by fetchdata
//py means padding alomg y axis
//gif willb fetched from api called using api key
//env is environment variable
//best prctce fior api call is useeffect
//const url = `https://api.giphy.com/v1/gifs/random?api_key=${API_KEY}`;..is the url on which api call will be made using api key
